export const fileTypes = {
  entities: 'Entities',
  class: 'Class',
  relation: 'Relation',
  macroGrammar: 'MacroGrammar',
  rule: 'Rule',
  computation: 'Computation',
  vocabulary: 'Vocabulary',
  questionTemplate: 'QuestionTemplate',
  discovery: 'Discovery',
  coOccurrenceDeclaration: 'CoOccurrenceDeclaration',
  question: 'Question',
  groundTruth: 'GroundTruth',
  table: 'Table',
  schema: 'Schema',
  database: 'Database',
  storage: 'Storage',
  coOccurrenceFacts: 'CoOccurrenceFacts',
  syncedEntities: 'SyncedEntities',
  definition: 'Definition',
  ontology: 'Ontology',
  board: 'Board',
  evolutions: 'Evolutions',
  variables: 'Variables'
};

export const creatableFileTypes = new Map([
  [fileTypes.class, 'Class'],
  [fileTypes.relation, 'Relation'],
  [fileTypes.rule, 'Rewriting Rule'],
  [fileTypes.macroGrammar, 'Macro Grammar'],
  [fileTypes.entities, 'Entities of a Class'],
  [fileTypes.computation, 'Function'],
  [fileTypes.vocabulary, 'Vocabulary'],
  [fileTypes.questionTemplate, 'Question Template'],
  [fileTypes.discovery, 'Discovery'],
  [fileTypes.coOccurrenceDeclaration, 'Class Co-Occurrence Declaration'],
  [fileTypes.board, 'Board'],
  [fileTypes.evolutions, 'Evolutions'],
  [fileTypes.variables, 'Variables'],
  [fileTypes.groundTruth, 'Ground Truth']
]);

// These file types always have the same identifier (and can thus only exist once in the KG)
// The identifier (values of the map) is displayed to the user in the form, but actually ignored by the backend
export const fileTypesWithFixedIdentifier = new Map([[fileTypes.evolutions, 'evolutions']]);
